import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { GetClientOverviewProfileById } from "../../../../../../actions/admin-provider/GetClientOverviewProfileById";
import { decryptId } from "../../../../../../common/encryptDecrypt/encryptdecrypt";
import ThreeDotBouncing from "../../../../../../common/element/PageLoader";
import BtnLight from "../../../../../../common/element/Buttons/btnLight";
import Tooltip from "../../../../../../common/element/Tooltip";
import Select from "../../../../../../common/element/Select";
import BtnPrimary from "../../../../../../common/element/Buttons/btnPrimary";
import { GetProviderPaymentResponsibleType } from "../../../../../../actions/admin-provider/clients/GetProviderPaymentResponsibleType";
import { useSelector } from "react-redux";
import Dialog from "../../../../../../common/element/Dialog/Dialog";
import ContractorIcon from "../../../../../../assets/icons-svg/cons-provider.svg";
import { GetProviderPaymentTypeInfo } from "../../../../../../actions/admin-provider/clients/GetProviderPaymentTypeInfo";
import PaymentMethod from "./payment";
const ClientDetails = ({ indivisualData, onDialogClose }) => {
  const { SpecificProviderData } = useSelector((state) => state);
  const [getCLientData, SetGetCLientData] = useState("");
  const [dialogChoose, SetDialogChoose] = useState(false);
  const [paymentToggle, setPaymentToggle] = useState({
    current_pay_responsibility: "",
    cycle_start_date: "",
    last_responsibility_change: "",
  });

  const [payee, setPayee] = useState(null);
  const [paymentInfo, setPaymentInfo] = useState(null);
  const { id } = useParams();
  const orgId = decryptId(id);
  const [loadData, setLoadData] = useState(false);
  const [subInbetween, setSubInbetween] = useState("");
  const [error, setError] = useState("");
  const [stepForm, setStepForm] = useState(false);
  const [dialogConfirmationOpen, setDialogConfirmationOpen] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      GetClientOverviewProfileById({
        organisation_id: indivisualData?.organisation_id,
        provider_org_id: orgId,
      })
    ).then((response) => {
      if (response.success) {
        SetGetCLientData(response.data);
        setLoadData(true);
      } else {
        setLoadData(true);
      }
    });

    let payload = {
      f_a_relation_id: indivisualData?.f_a_relation_id,
      provider_org_id: orgId,
      client_org_id: indivisualData?.organisation_id,
    };
    dispatch(GetProviderPaymentResponsibleType(payload)).then((response) => {
      if (response.success) {
        setPaymentToggle(response.data);
        if (response.data?.end_date) {
          const cycleStartDate = new Date(response.data.end_date);
          const currentDate = new Date();

          // Calculate the difference in days
          const diffInDays =
            (cycleStartDate - currentDate) / (1000 * 60 * 60 * 24);

          if (diffInDays < 20) {
            setSubInbetween("Cycle in between");
          }
        }
      }
    });
  }, []);

  useEffect(() => {
    if (dialogChoose) {
      let payload = {
        f_a_relation_id: indivisualData?.f_a_relation_id,
        provider_org_id: orgId,
        client_org_id: indivisualData?.organisation_id,
        provider_type_id: SpecificProviderData?.provider_type_id,
        current_pay_responsibility: paymentToggle?.current_pay_responsibility,
        newPayResponsible:
          paymentToggle?.current_pay_responsibility == "client_pays"
            ? "provider_pays"
            : "client_pays",
      };
      dispatch(GetProviderPaymentTypeInfo(payload)).then((response) => {
        if (response?.success) {
          setPaymentInfo(response?.data);
        } else {
          if (response?.success == false || response?.success == "false") {
            setError(response.message?.message?.msg);
          }
        }
      });
    }
  }, [dialogChoose]);

  if (!loadData) {
    return (
      <div>
        <ThreeDotBouncing />
      </div>
    );
  }

  const isDisabled =
    (paymentToggle?.last_responsibility_change &&
      new Date(paymentToggle?.cycle_start_date) <
      new Date(paymentToggle?.last_responsibility_change)) ||
    subInbetween != "";
  const onChooseClose = () => {
    SetDialogChoose(false);
    setPayee(null);
    setStepForm(false);
  };
  const handleEditClick = () => {
    SetDialogChoose(true);
  };

  const handleData = (data) => {
    setPayee(data.value);
  };

  const onDialogConfirmationClose = () => {
    setDialogConfirmationOpen(false);
  };

  const HandleConfirm = () => {
    setStepForm(true);
    onDialogConfirmationClose();
  };

  return (
    <div className="flex w-full">
      <div className="border h-72 border-gray-300 rounded-lg w-56 flex items-center text-center justify-center">
        {/* <span className="text-xs text-gray-400 font-semibold"> */}
        {/* Client logo here, */}
        <img src={getCLientData?.logo} />
        {/* <br /> if available */}
        {/* </span> */}
      </div>
      <div className="flex w-4/6 pl-5">
        <div className="w-3/6">
          <div className="flex flex-col mb-5">
            <label className="text-xs font-medium">Client name</label>
            <div className="text-gray-900 font-semibold">
              {/* [Client name here] */}
              {getCLientData?.trading_name}
            </div>
          </div>
          <div className="flex flex-col mb-5">
            <label className="text-xs font-medium">Email address</label>
            <div className="text-gray-900 font-semibold">
              {getCLientData?.provClientCont?.contact_email || "-"}
            </div>
          </div>
          <div className="flex flex-col mb-5">
            <label className="text-xs font-medium">Website</label>
            <Link
              to={getCLientData?.website_url}
              className="text-xs text-blue-700 flex gap-1"
            >
              {getCLientData?.website_url}
              <svg
                width="13"
                height="12"
                viewBox="0 0 13 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.167 4.5v-3m0 0h-3m3 0-4 4m-1.5-3h-1.1c-.84 0-1.26 0-1.581.163a1.5 1.5 0 0 0-.656.656c-.163.32-.163.74-.163 1.581v3.2c0 .84 0 1.26.163 1.581a1.5 1.5 0 0 0 .656.655c.32.164.74.164 1.58.164h3.2c.84 0 1.26 0 1.582-.164a1.5 1.5 0 0 0 .655-.655c.164-.32.164-.74.164-1.581V7"
                  stroke="#5786cc"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </Link>
          </div>
          <div className="flex flex-col mb-5">
            <div class="flex mb-0">
              <div class="flex-1">
                <span class="text-gray-400 font-semibold block text-sm mb-1">
                  Address1
                </span>
                <span class="text-gray-900 font-medium block text-sm">
                  {getCLientData?.org_address_data?.[0]?.address_one?getCLientData?.org_address_data?.[0]?.address_one:"-"}
                </span>
              </div>
              <div class="flex-1">
                <span class="text-gray-400 font-semibold block text-sm mb-1">
                  Address2
                </span>
                <span class="text-gray-900 font-medium block text-sm">
                  {getCLientData?.org_address_data?.[0]?.address_two?getCLientData?.org_address_data?.[0]?.address_two:"-"}
                </span>
              </div>
            </div>
            <div class="flex mb-0">
              <div class="flex-1">
                <span class="text-gray-400 font-semibold block text-sm mb-1">
                  Country
                </span>
                <span class="text-gray-900 font-medium block text-sm">
                  {getCLientData?.org_address_data?.[0]?.country_name?getCLientData?.org_address_data?.[0]?.country_name:"-"}
                </span>
              </div>
              <div class="flex-1">
                <span class="text-gray-400 font-semibold block text-sm mb-1">
                  State
                </span>
                <span class="text-gray-900 font-medium block text-sm">
                  {getCLientData?.org_address_data?.[0]?.state_name?getCLientData?.org_address_data?.[0]?.state_name:"-"}
                </span>
              </div>
            </div>
            <div class="flex mb-0 border-t-2 mt-4">
              <div class="flex justify-between w-full items-center mt-2">
                <div>
                  <span class="text-gray-400 font-semibold block text-sm mb-1">
                    Payment type
                  </span>
                  <span class="text-gray-900 font-medium block text-sm">
                    {paymentToggle?.current_pay_responsibility =="client_pays"? "Client pays" :"Provider pays"}
                  </span>
                  {subInbetween && (
                    <p className="text-red-500 text-sm">{subInbetween}</p>
                  )}
                </div>

                <Tooltip
                  title="Provider payment type not available!"
                  placement="top"
                  disabled={!!paymentToggle?.current_pay_responsibility}                 >
                  <div>
                    <BtnLight
                      className={`h-9 w-20 flex items-center justify-center gap-2 ${!paymentToggle?.current_pay_responsibility ? "text-gray-400" : ""
                        }`}
                      disabled={isDisabled}
                      onClick={
                        paymentToggle?.current_pay_responsibility ? handleEditClick : undefined
                      }
                    >
                      Edit
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M14.9999 8.33326L11.6666 4.99993M2.08325 17.9166L4.90356 17.6032C5.24813 17.5649 5.42042 17.5458 5.58146 17.4937C5.72433 17.4474 5.86029 17.3821 5.98566 17.2994C6.12696 17.2062 6.24954 17.0836 6.49469 16.8385L17.4999 5.83326C18.4204 4.91279 18.4204 3.4204 17.4999 2.49993C16.5795 1.57945 15.0871 1.57945 14.1666 2.49992L3.16136 13.5052C2.91621 13.7503 2.79363 13.8729 2.70045 14.0142C2.61778 14.1396 2.55243 14.2755 2.50618 14.4184C2.45405 14.5794 2.43491 14.7517 2.39662 15.0963L2.08325 17.9166Z"
                          stroke="black"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </BtnLight>
                  </div>
                </Tooltip>

              </div>
            </div>
          </div>
        </div>
        <div className="w-3/6">
          <div className="flex flex-col mb-5">
            <label className="text-xs font-medium">ABN/NZBN</label>
            <div className="text-gray-900 font-semibold">
              {getCLientData?.abn_nzbn?getCLientData?.abn_nzbn:"-"}
            </div>
          </div>
          <div className="flex flex-col mb-5">
            <label className="text-xs font-medium">Contact number</label>
            <div className="text-gray-900 font-semibold">
              {getCLientData?.org_phone?getCLientData?.org_phone:"-"}
            </div>
          </div>
        </div>
      </div>
      <Dialog
        isOpen={dialogChoose}
        onClose={onChooseClose}
        onRequestClose={onChooseClose}
        bodyOpenClassName="overflow-hidden"
        width={720}
      >
        <div className="flex border-b mb-5 pb-5 px-6 pt-6 items-center">
          <span className="h-12 w-12 border rounded-lg border-gray-200 flex items-center justify-center shadow-sm mr-4">
            <img src={ContractorIcon} alt="" />
          </span>
          <div>
            <h5 className="mb-0 text-gray-900 text-base font-semibold">
            {`${SpecificProviderData?.trading_name}'s payment type`}
            </h5>
          </div>
        </div>
        <div className="px-6">
          <div className="mb-5">
            <React.Fragment>
              <label className="font-medium text-gray-700 w-1/4 mb-1 block">
                Provider type*
              </label>
              <div className="w-full hide-select-elt">
                <Select
                  className="w-full h-9 select-options"
                  placeholder="Select provider type"
                  options={[
                    {
                      // label: "provider payee",
                      label: "Provider pays",
                      value: "provider_pays",
                      isDisabled:
                        paymentToggle?.current_pay_responsibility ===
                        "provider_pays",
                    },
                    {
                      // label: "client payee",
                      label: "Client pays",
                      value: "client_pays",
                      isDisabled:
                        paymentToggle?.current_pay_responsibility ===
                        "client_pays",
                    },
                  ]}
                  onChange={handleData}
                ></Select>
              </div>
            </React.Fragment>

            {stepForm && (
              <PaymentMethod
                onDialogClose={onDialogClose}
                openUnsaveDialog={onChooseClose}
                abn_nzbn={getCLientData?.abn_nzbn}
                client_trading_name={getCLientData?.trading_name}
                paymentInfo={paymentInfo}
                updateObject={{
                  f_a_relation_id: indivisualData?.f_a_relation_id,
                  provider_org_id: orgId,
                  client_org_id: indivisualData?.organisation_id,
                  provider_type_id: SpecificProviderData?.provider_type_id,
                  newPayResponsible: payee,
                }}
              />
            )}
          </div>
        </div>
        {paymentInfo?.isClientBillPending && (
          <p className="text-red-500 text-sm ml-5">Client billing pending!</p>
        )}
        {paymentInfo?.isProviderSubscExpired && (
          <p className="text-red-500 text-sm ml-5">
            Provider subscription expired!
          </p>
        )}

        {error && <p className="text-red-500 text-sm ml-5">{error}</p>}

        {!stepForm && (
          <div className="flex dailog-footer ">
            <BtnLight
              className="mr-1.5"
              variant="plain"
              onClick={onChooseClose}
            >
              Cancel
            </BtnLight>
            <BtnPrimary
              className="ml-1.5"
              disabled={
                // payee != undefined ||
                // payee != null ||
                // paymentInfo?.isClientBillPending ||
                // paymentInfo?.isProviderSubscExpired ||
                // error == ""
                //   ? false
                //   : true
                !payee ||
                paymentInfo?.isClientBillPending ||
                paymentInfo?.isProviderSubscExpired ||
                error !== ""
              }
              onClick={() => setDialogConfirmationOpen(true)}
            >
              Done
            </BtnPrimary>
          </div>
        )}
      </Dialog>
      <Dialog
        isOpen={dialogConfirmationOpen}
        onClose={onDialogConfirmationClose}
        onRequestClose={onDialogConfirmationClose}
        bodyOpenClassName="overflow-hidden"
        className="customAlert"
      >
        <div className="px-6 pt-6">
          <span className="w-12 h-12 rounded-full m-auto bg-error-100 flex items-center justify-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="48"
              height="48"
              viewBox="0 0 48 48"
              fill="none"
            >
              <rect
                x="0.5"
                y="0.5"
                width="47"
                height="47"
                rx="23.5"
                fill="#D2EBFF"
              />
              <rect
                x="0.5"
                y="0.5"
                width="47"
                height="47"
                rx="23.5"
                stroke="#ECFDF3"
              />
              <path
                d="M24 20V24M24 28H24.01M14 20.5227V27.4773C14 27.7218 14 27.8441 14.0276 27.9592C14.0521 28.0613 14.0925 28.1588 14.1474 28.2483C14.2092 28.3492 14.2957 28.4357 14.4686 28.6086L19.3914 33.5314C19.5643 33.7043 19.6508 33.7908 19.7517 33.8526C19.8412 33.9075 19.9387 33.9479 20.0408 33.9724C20.1559 34 20.2782 34 20.5227 34H27.4773C27.7218 34 27.8441 34 27.9592 33.9724C28.0613 33.9479 28.1588 33.9075 28.2483 33.8526C28.3492 33.7908 28.4357 33.7043 28.6086 33.5314L33.5314 28.6086C33.7043 28.4357 33.7908 28.3492 33.8526 28.2483C33.9075 28.1588 33.9479 28.0613 33.9724 27.9592C34 27.8441 34 27.7218 34 27.4773V20.5227C34 20.2782 34 20.1559 33.9724 20.0408C33.9479 19.9387 33.9075 19.8412 33.8526 19.7517C33.7908 19.6508 33.7043 19.5643 33.5314 19.3914L28.6086 14.4686C28.4357 14.2957 28.3492 14.2092 28.2483 14.1474C28.1588 14.0925 28.0613 14.0521 27.9592 14.0276C27.8441 14 27.7218 14 27.4773 14H20.5227C20.2782 14 20.1559 14 20.0408 14.0276C19.9387 14.0521 19.8412 14.0925 19.7517 14.1474C19.6508 14.2092 19.5643 14.2957 19.3914 14.4686L14.4686 19.3914C14.2957 19.5643 14.2092 19.6508 14.1474 19.7517C14.0925 19.8412 14.0521 19.9387 14.0276 20.0408C14 20.1559 14 20.2782 14 20.5227Z"
                stroke="black"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </span>
          <p className="text-base text-gray-900 font-semibold text-center mt-4">
            Are you sure?
          </p>
          <p className=" text-gray-600 text-center mt-1">
            This action will require you to charge the{" "}
            {paymentToggle?.current_pay_responsibility == "client_pays"
              ? "Provider"
              : "Client"}{" "}
            for the payment immediately.
          </p>
        </div>
        <div className="mt-8 flex justify-between pb-6 px-6 gap-2">
          <BtnLight onClick={onDialogConfirmationClose}>Close</BtnLight>
          <BtnPrimary onClick={HandleConfirm}>Confirm</BtnPrimary>
        </div>
      </Dialog>
    </div>
  );
};

export default ClientDetails;
